import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";

import DeleteModal from "../../../../Components/Common/DeleteModal";

import { toast } from "react-toastify";
import {
  addNewOpportunityPriority,
  addNewOpportunityPrioritySuccess,
  addNewOpportunityStatus,
  addNewOpportunityStatusSuccess,
  addNewOpportunityType,
  addNewOpportunityTypeSuccess,
  deleteOpportunityPriority,
  deleteOpportunityPrioritySuccess,
  deleteOpportunityStatus,
  deleteOpportunityStatusSuccess,
  deleteOpportunityType,
  deleteOpportunityTypeSuccess,
  opportunitiesPriorityList,
  opportunitiesStatusList,
  opportunitiesTypeList,
  updateOpportunityPriority,
  updateOpportunityPrioritySuccess,
  updateOpportunityStatus,
  updateOpportunityStatusSuccess,
  updateOpportunityType,
  updateOpportunityTypeSuccess,
} from "../../../../store/opportunities/action";
export default function OpportunitySettings() {
  const dispatch = useDispatch();

  const {
    opportunitiesStatusListAPI,
    opportunitiesPriorityListAPI,
    opportunitiesTypeListAPI,
  } = useSelector((state) => ({
    opportunitiesStatusListAPI:
      state.Opportunities.opportunitiesStatusList?.opportunitystatus_list,
    opportunitiesPriorityListAPI:
      state.Opportunities.opportunitiesPriorityList?.opportunitypriority_list,
    opportunitiesTypeListAPI:
      state.Opportunities.opportunitiesTypeList?.opportunitytype_list,
  }));
  const [statusList, setStatusList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
  });
  const [noColourChoiceRequired, setNoColourChoiceRequired] = useState(false);

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      //   Status create
      dispatch(addNewOpportunityStatus([createStatus]));
    }
    if (activeTab === "2") {
      //   priority  create
      dispatch(addNewOpportunityPriority([createStatus]));
    }
    if (activeTab === "3") {
      //   Type create
      dispatch(addNewOpportunityType([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = opportunitiesStatusListAPI?.sort((a, b) => b.Id - a.Id);
      setNoColourChoiceRequired(false);
    }
    if (activeTab === "2") {
      data = opportunitiesPriorityListAPI?.sort((a, b) => b.Id - a.Id);
      setNoColourChoiceRequired(true);
    }
    if (activeTab === "3") {
      data = opportunitiesTypeListAPI?.sort((a, b) => b.Id - a.Id);
      setNoColourChoiceRequired(true);
    }
    setStatusList(data);
  }, [
    opportunitiesStatusListAPI,
    opportunitiesPriorityListAPI,
    opportunitiesTypeListAPI,
    activeTab,
  ]);

  useEffect(() => {
    dispatch(opportunitiesStatusList());
    dispatch(opportunitiesPriorityList());
    dispatch(opportunitiesTypeList());
  }, []);

  const Tabs = [
    {
      id: "1",
      name: "Statuses",
    },
    {
      id: "2",
      name: "Priority",
    },
    {
      id: "3",
      name: "Type",
    },
  ];
  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      //   Status delete
      dispatch(deleteOpportunityStatus([deleteStatus]));
    }
    if (activeTab === "2") {
      //  priority delete
      dispatch(deleteOpportunityPriority([deleteStatus]));
    }
    if (activeTab === "3") {
      //  Type delete
      dispatch(deleteOpportunityType([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        //  Status update
        dispatch(updateOpportunityStatus([updateNewStatus]));
      }
      if (activeTab === "2") {
        //  priority update
        dispatch(updateOpportunityPriority([updateNewStatus]));
      }
      if (activeTab === "3") {
        //  Type update
        dispatch(updateOpportunityType([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  // Success effects Opertunity Status, type , priority
  const {
    addNewOpportunityStatusSuccessApi,
    addNewOpportunityPrioritySuccessApi,
    addNewOpportunityTypeSuccessApi,
    deleteOpportunityStatusSuccessApi,
    deleteOpportunityPrioritySuccessApi,
    deleteOpportunityTypeSuccessApi,
    updateOpportunityStatusSuccessApi,
    updateOpportunityPrioritySuccessApi,
    updateOpportunityTypeSuccessApi,
  } = useSelector((state) => ({
    addNewOpportunityStatusSuccessApi:
      state.Opportunities.addNewOpportunityStatusSuccess,
    addNewOpportunityPrioritySuccessApi:
      state.Opportunities.addNewOpportunityPrioritySuccess,
    addNewOpportunityTypeSuccessApi:
      state.Opportunities.addNewOpportunityTypeSuccess,
    deleteOpportunityStatusSuccessApi:
      state.Opportunities.deleteOpportunityStatusSuccess,
    deleteOpportunityPrioritySuccessApi:
      state.Opportunities.deleteOpportunityPrioritySuccess,
    deleteOpportunityTypeSuccessApi:
      state.Opportunities.deleteOpportunityTypeSuccess,
    updateOpportunityStatusSuccessApi:
      state.Opportunities.updateOpportunityStatusSuccess,
    updateOpportunityPrioritySuccessApi:
      state.Opportunities.updateOpportunityPrioritySuccess,
    updateOpportunityTypeSuccessApi:
      state.Opportunities.updateOpportunityTypeSuccess,
  }));

  // Add new Status
  useEffect(() => {
    if (isEmpty(addNewOpportunityStatusSuccessApi)) return;
    if (addNewOpportunityStatusSuccessApi.status === 200) {
      toast.success(addNewOpportunityStatusSuccessApi?.message);
      dispatch(opportunitiesStatusList());
    } else {
      toast.error(addNewOpportunityStatusSuccessApi?.message);
    }
    dispatch(addNewOpportunityStatusSuccess([]));
  }, [addNewOpportunityStatusSuccessApi]);

  // Add new priority
  useEffect(() => {
    if (isEmpty(addNewOpportunityPrioritySuccessApi)) return;
    if (addNewOpportunityPrioritySuccessApi.status === 200) {
      toast.success(addNewOpportunityPrioritySuccessApi?.message);
      dispatch(opportunitiesPriorityList());
    } else {
      toast.error(addNewOpportunityPrioritySuccessApi?.message);
    }
    dispatch(addNewOpportunityPrioritySuccess([]));
  }, [addNewOpportunityPrioritySuccessApi]);

  // Add new Type
  useEffect(() => {
    if (isEmpty(addNewOpportunityTypeSuccessApi)) return;
    if (addNewOpportunityTypeSuccessApi.status === 200) {
      toast.success(addNewOpportunityTypeSuccessApi?.message);
      dispatch(opportunitiesTypeList());
    } else {
      toast.error(addNewOpportunityTypeSuccessApi?.message);
    }
    dispatch(addNewOpportunityTypeSuccess([]));
  }, [addNewOpportunityTypeSuccessApi]);

  // Delete Status
  useEffect(() => {
    if (isEmpty(deleteOpportunityStatusSuccessApi)) return;
    if (deleteOpportunityStatusSuccessApi.status === 200) {
      toast.success(deleteOpportunityStatusSuccessApi?.message);
      dispatch(opportunitiesStatusList());
      setDeleteModal(false);
    } else {
      toast.error(deleteOpportunityStatusSuccessApi?.message);
    }
    dispatch(deleteOpportunityStatusSuccess([]));
  }, [deleteOpportunityStatusSuccessApi]);

  // Delete priority
  useEffect(() => {
    if (isEmpty(deleteOpportunityPrioritySuccessApi)) return;
    if (deleteOpportunityPrioritySuccessApi.status === 200) {
      toast.success(deleteOpportunityPrioritySuccessApi?.message);
      dispatch(opportunitiesPriorityList());
      setDeleteModal(false);
    } else {
      toast.error(deleteOpportunityPrioritySuccessApi?.message);
    }
    dispatch(deleteOpportunityPrioritySuccess([]));
  }, [deleteOpportunityPrioritySuccessApi]);

  // Delete Type
  useEffect(() => {
    if (isEmpty(deleteOpportunityTypeSuccessApi)) return;
    if (deleteOpportunityTypeSuccessApi.status === 200) {
      toast.success(deleteOpportunityTypeSuccessApi?.message);
      dispatch(opportunitiesTypeList());
      setDeleteModal(false);
    } else {
      toast.error(deleteOpportunityTypeSuccessApi?.message);
    }
    dispatch(deleteOpportunityTypeSuccess([]));
  }, [deleteOpportunityTypeSuccessApi]);

  // Update Status
  useEffect(() => {
    if (isEmpty(updateOpportunityStatusSuccessApi)) return;
    if (updateOpportunityStatusSuccessApi.status === 200) {
      toast.success(updateOpportunityStatusSuccessApi?.message);
      dispatch(opportunitiesStatusList());
    } else {
      toast.error(updateOpportunityStatusSuccessApi?.message);
    }
    dispatch(updateOpportunityStatusSuccess([]));
  }, [updateOpportunityStatusSuccessApi]);

  // Update priority
  useEffect(() => {
    if (isEmpty(updateOpportunityPrioritySuccessApi)) return;
    if (updateOpportunityPrioritySuccessApi.status === 200) {
      toast.success(updateOpportunityPrioritySuccessApi?.message);
      dispatch(opportunitiesPriorityList());
    } else {
      toast.error(updateOpportunityPrioritySuccessApi?.message);
    }
    dispatch(updateOpportunityPrioritySuccess([]));
  }, [updateOpportunityPrioritySuccessApi]);

  // Update Type
  useEffect(() => {
    if (isEmpty(updateOpportunityTypeSuccessApi)) return;
    if (updateOpportunityTypeSuccessApi.status === 200) {
      toast.success(updateOpportunityTypeSuccessApi?.message);
      dispatch(opportunitiesTypeList());
    } else {
      toast.error(updateOpportunityTypeSuccessApi?.message);
    }
    dispatch(updateOpportunityTypeSuccess([]));
  }, [updateOpportunityTypeSuccessApi]);

  return (
    <>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteStatus}
          onCloseClick={() => {
            setDeleteModal(false);
          }}
        />
      )}

      <SettingsPanel
        title="Opportunity Settings"
        description="Statuses, priorities and types for opportunities"
        tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
        value={activeTab}
        onChange={setActiveTab}
      >
        <StatusViewEditComponent
          statusList={statusList}
          setStatusList={setStatusList}
          createStatus={createStatus}
          setCreateStatus={setCreateStatus}
          handleCreateNewStatus={handleCreateNewStatus}
          setDeleteStatus={setDeleteStatus}
          setDeleteModal={setDeleteModal}
          setUpdateItemStatus={setUpdateItemStatus}
          noColourChoiceRequired={noColourChoiceRequired}
        />
      </SettingsPanel>
    </>
  );
}
